import App from './app/core/app';
import '../styles/index.scss';

require('./app/components/polyfill/polyfills');
import Preload from './app/components/preload/preload';
import Device from './app/components/device/device';
/*import Alert from './app/components/alerts/alerts';*/
import Anchor from './app/components/anchor';
/*import Lazy from './app/components/lazy';*/
import Menu from './app/components/menu';
/*import Scrollbar from './app/components/scrollbar';*/
import Main from './main';

const components = [
	Preload,
	Device,
	/*Alert,*/
	Anchor,
	/*Lazy,*/
	Menu,
	/*Scrollbar,*/
	Main
];

App.use( components );